export var LOAD_APPADMINS_REQUEST = 'app/appadmins/LOAD_APPADMINS_REQUEST';
export var LOAD_APPADMINS_SUCCESS = 'app/appadmins/LOAD_APPADMINS_SUCCESS';
export var LOAD_APPADMINS_FAILURE = 'app/appadmins/LOAD_APPADMINS_FAILURE';
